import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import LrfService from '../../../../../services/lrf-auth';
import { Link, useParams, Navigate } from 'react-router-dom';






const Diario = () => {
    let { id } = useParams()
    const [ano, setAno] = useState("");
    const [bimestre, setBimestre] = useState("");

    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchLrf(id) {
        const response = await LrfService.lrfEdit(id);
        setAno(response.data["ano"]);
        setBimestre(response.data["bimestre"]);

    }

    useEffect(() => {
        fetchLrf(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const diario = await LrfService.editar(id, {
                bimestre: bimestre,
                ano: ano
            })
            if (diario.data["cod_lrf"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                <Row xs={1} lg={2}>
                        <Col>
                            <Form.Group className="mb-3" controlId="Bimestre">
                                <FloatingLabel
                                    label="Bimestre"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Bimestre"
                                        name="bimestre"
                                        onChange={e => setBimestre(e.target.value)}
                                    >
                                        <option value={bimestre}>{bimestre}</option>
                                        <option value="1bim">1º Bimestre (RREO)</option>
                                        <option value="2bim">2º Bimestre (RREO)</option>
                                        <option value="3bim">3º Bimestre (RREO)</option>
                                        <option value="1sem">1º Semestre (RGF)</option>
                                        <option value="4bim">4º Bimestre (RREO)</option>
                                        <option value="5bim">5º Bimestre (RREO)</option>
                                        <option value="6bim">6º Bimestre (RREO)</option>
                                        <option value="2sem">2º Semestre (RGF)</option>
                                        <option value="1qua">1º Quadrimestre (RGF)</option>
                                        <option value="2qua">2º Quadrimestre (RGF)</option>
                                        <option value="3qua">3º Quadrimestre (RGF)</option>
                                        <option value="ano">Anual (DCRGF)</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option value={ano}>{ano}</option>
                                        <option value="2025">2025</option>
                                        <option value="2024">2024</option>
                                        <option value="2023">2023</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2026">2026</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/lrf/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>LRF editada com sucesso!</Alert>
                <Navigate to={'/restrito/lrf/listar'} />
            </Fragment>
        )
    }
}

export default Diario;